import { useCallback, useEffect, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import {
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button/Button.model';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { formatTime } from '~/shared';
import { setCarMarketState, useLayoutDispatch } from '../../redux';
import { CarMarketState } from '../../views/CarMarket/CarMarket.model';
import {
	StyledContainer,
	StyledEditButton,
	StyledRightContainer,
	StyledTimer,
} from './Head.styled';

const Head = ({
	title,
	canEdit,
	expiresAt,
}: {
	title: string;
	canEdit?: boolean;
	expiresAt?: number;
}) => {
	const dispatch = useLayoutDispatch();

	const [timeLeft, setTimeLeft] = useState(0);

	const handleEdit = useCallback(() => {
		dispatch(setCarMarketState(CarMarketState.Edit));
	}, []);

	useEffect(() => {
		if (!expiresAt) return;

		const updateTime = () => {
			setTimeLeft(Math.max(0, expiresAt - Date.now()));
		};

		updateTime();
		const interval = setInterval(updateTime, 1000);

		return () => clearInterval(interval);
	}, [expiresAt]);

	return (
		<StyledContainer>
			<Text>{title}</Text>
			<StyledRightContainer>
				{canEdit && (
					<StyledEditButton
						onClick={() => {
							handleEdit();
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						<Text>Редактировать</Text>
					</StyledEditButton>
				)}
				{expiresAt ? (
					<StyledTimer>
						<Text>{formatTime(timeLeft, '{hh}:{mm}')}</Text>
					</StyledTimer>
				) : null}
				<CloseButton
					height={ButtonHeight.Height20}
					iconSize={10}
					borderRadius={ButtonBorderRadius.Radius5}
					color={ButtonColors.Default}
					onClick={() => rage.vehicleMarket.exitMenu()}
				/>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { Head };
